<template>
  <div>
    <h3 class="text-lg font-medium mb-4">Manage related resources</h3>
    <p class="mb-2">
      There {{ mediablesCount > 1 ? 'are' : 'is' }} currently {{ mediablesCount }}
      {{ mediablesCount > 1 ? 'resources' : 'resource' }}
      associated with this media item.
    </p>
    <p class="mb-4 text-small text-teal-900">
      You can update all related resources with a new media item.
    </p>
    <BaseVeeForm :action="submitForm">
      <!-- formProps
        isIdle, isPending, isResolved, isRejected, invalid
        errors, submit
      -->
      <template #default="formProps">
        <div class="space-y-4">
          <MediaSelectInput v-model="newMediaItem" :disabled="formProps.isPending" class="w-1/2" />
          <BaseFormInlineMessage v-if="newMediaItemIsSame" info>
            You cannot replace with the same media item.
          </BaseFormInlineMessage>
          <BaseButton
            primary
            outline
            :disabled="
              !hasSelectedMediaItem ||
              newMediaItemIsSame ||
              !newMediaItemHasValidMimeType ||
              formProps.isPending
            "
          >
            Replace
          </BaseButton>
        </div>
      </template>
    </BaseVeeForm>
  </div>
</template>

<script>
import { mediaLibraryMediablesMoveClient } from '@/api/clients/admin';
import MediaSelectInput from './MediaSelectInput.vue';

export default {
  components: { MediaSelectInput },
  props: {
    currentMediaItem: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      newMediaItem: null,
    };
  },
  computed: {
    hasSelectedMediaItem() {
      return this.newMediaItem !== null;
    },
    newMediaItemIsSame() {
      return this.hasSelectedMediaItem && this.newMediaItem.id === this.currentMediaItem.id;
    },
    newMediaItemHasValidMimeType() {
      if (!this.hasSelectedMediaItem) {
        return false;
      }

      const { mimeType: currentMimeType } = this.currentMediaItem;
      const { mimeType: newMimeType } = this.newMediaItem;

      if (currentMimeType === newMimeType) {
        return true;
      }

      return ['image/', 'video/'].some(
        (searchString) =>
          currentMimeType.startsWith(searchString) && newMimeType.startsWith(searchString)
      );
    },
    mediablesCount() {
      return this.currentMediaItem.mediablesCount;
    },
  },
  methods: {
    async submitForm() {
      try {
        if (!this.currentMediaItem.id || !this.newMediaItem.id) {
          throw new Error('Missing required post data');
        }

        this.$emit('replacing');

        await mediaLibraryMediablesMoveClient.store({
          media_id_from: this.currentMediaItem.id,
          media_id_to: this.newMediaItem.id,
        });

        this.$emit('replaced');

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      } finally {
        this.$emit('finished');
      }
    },
  },
};
</script>
